import _ from 'lodash';
import qs from 'qs';
import request from '../request';
import { API } from '../../../global-constants';

const create = content =>
  request({
    baseURL: API.BASE_URL,
    url: API.STAFF_WORK_ORDER_TYPE,
    method: 'POST',
    data: content,
  });

const update = content =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.STAFF_WORK_ORDER_TYPE}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const remove = id =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.STAFF_WORK_ORDER_TYPE}/${id}`,
    method: 'DELETE',
  });

const getAll = () =>
  request({
    baseURL: API.BASE_URL,
    url: API.STAFF_WORK_ORDER_TYPE,
    method: 'GET',
    params: {},
  });

const searchByDescription = searchText =>
  request({
    baseURL: API.BASE_URL,
    url: API.STAFF_WORK_ORDER_TYPE,
    method: 'GET',
    params: {
      filter: [
        searchText && {
          type: 'like',
          field: 'description',
          value: `%${searchText}%`,
        },
      ].filter(o => o),
      'order-by': [
        {
          type: 'field',
          field: 'description',
          direction: 'asc',
        },
      ],
    },
    paramsSerializer: params => qs.stringify(params),
  });

const getOptions = (inputValue, callback) => {
  searchByDescription(inputValue).then(results => {
    callback(
      _.get(results, 'data._embedded.staff-workorder-type', []).map(
        typology => ({
          value: typology.id,
          label: `${typology.description}`,
        }),
      ),
    );
  });
};

const getStaffWorkorderTypeOptions = () =>
  getAll().then(res =>
    _.get(res, 'data._embedded.staff-workorder-type', []).map(type => ({
      value: type.id,
      label: `${type.description}`,
    })),
  );

const StaffWorkOrderTypeService = {
  create,
  update,
  remove,
  getAll,
  getOptions,
  getStaffWorkorderTypeOptions,
};

export default StaffWorkOrderTypeService;
